import { createRouter, createWebHistory } from "vue-router";
import Cookies from "js-cookie"; // ✅ 引入 cookie 工具
import Swal from "sweetalert2";

// 需要引入 SystemLayout 和 SystemDashboard 這兩個組件
// import SystemLayout from "@/components/systemset/SystemLayout.vue";
// import SystemDashboard from "@/components/systemset/SystemDashboard.vue";
// import SystemLayout from "@/components/SystemLayout.vue";

const routes = [
  //顧客前台

  {
    path: "/", // 空字串代表預設子路由
    name: "HomePage",
    component: () => import("@/components/HomePage.vue"),
  },

  {
    path: "/room",
    name: "room",
    component: () => import("@/components/RoomPage.vue"),
  },

  {
    path: "/booking",
    name: "booking",
    component: () => import("@/components/BookingPage.vue"),
  },

  {
    path: "/contact",
    name: "contact",
    component: () => import("@/components/ContactPage.vue"),
    meta: { hideFooter: true }
  },
  
  {
    path: "/travel",
    name: "travel",
    component: () => import("@/components/TravelPage.vue"),
    meta: { hideFooter: true }
  },

  // {
  //   path: "/about",
  //   name: "about",
  //   component: () => import("@/components/AboutPage.vue"),
  // },

  // ✅ 新增：404 錯誤頁面路由 - 必須放在所有路由的最後面
  // {
  //   path: "/:pathMatch(.*)*",
  //   name: "NotFound",
  //   component: () => import("@/components/NotFound.vue"),
  //   meta: { hideHeader: true, hideFooter: true },
  // },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  // 平滑滾動到頁面頂部
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0, behavior: "smooth" };
    }
  },
});

//  全域前置守衛：已登入者不能進 login/register 頁
router.beforeEach(async (to, from, next) => {
  const token = Cookies.get("token");

  // 已登入者不能進 login/register 頁
  if (token && (to.path === "/maincole/login" || to.path === "/register")) {
    next("/mainconsole");
    return;
  }

  // 檢查需要身份驗證的路由
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!token) {
      // ⬇️ 顯示提示
      await Swal.fire({
        icon: "warning",
        title: "請先登入",
        text: "您尚未登入，請先登入才能進入此頁面。",
        confirmButtonText: "前往登入",
      });

      // 停在登入畫面並保留原本欲前往的網址
      next({ path: "/maincole/login", query: { redirect: to.fullPath } });
      return;
    }
  }

  // 🔒 限制 /systemset 給 admin
  if (to.path === "/systemset") {
    try {
      const payload = token.split(".")[1];
      const decoded = JSON.parse(atob(payload));

      if (decoded.admin !== "true") {
        Swal.fire({
          icon: "error",
          title: "權限不足",
          text: "您沒有權限存取此頁面",
          timer: 1500,
          showConfirmButton: false,
        });
        next("/mainconsole");
        return;
      }
    } catch (err) {
      console.error("JWT 解析失敗", err);
      next("/mainconsole");
      return;
    }
  }

  // 檢查需要管理員權限的路由
  if (to.matched.some((record) => record.meta.requiresAdmin)) {
    if (!token) {
      await Swal.fire({
        icon: "warning",
        title: "請先登入",
        text: "請登入以確認您是否具有管理員權限。",
        confirmButtonText: "前往登入",
      });
      next({ path: "/", query: { redirect: to.fullPath } });
      return;
    }

    // 解析JWT token以獲取admin權限
    try {
      // 分割token並獲取payload部分
      const payload = token.split(".")[1];
      // 解碼base64
      const decodedPayload = JSON.parse(atob(payload));

      // 檢查admin權限
      if (decodedPayload.admin !== "true") {
        await Swal.fire({
          icon: "error",
          title: "權限不足",
          text: "您沒有管理員權限，無法存取此頁面。",
        });
        next({ path: "/maincole/login" });
        return;
      }
    } catch (error) {
      console.error("Token parsing error:", error);
      next({ path: "/maincole/login" });
      return;
    }
  }

  next(); // 其他情況照常通過
});

export default router;
